/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const CircleXFilledIcon = (props: Props) => (
  <svg
    className={classNames("icons fill ", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="0 0 24 24"
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path d="M12,10.5857864 L8.95710678,7.54289322 C8.56658249,7.15236893 7.93341751,7.15236893 7.54289322,7.54289322 C7.15236893,7.93341751 7.15236893,8.56658249 7.54289322,8.95710678 L10.5857864,12 L7.54289322,15.0428932 C7.15236893,15.4334175 7.15236893,16.0665825 7.54289322,16.4571068 C7.93341751,16.8476311 8.56658249,16.8476311 8.95710678,16.4571068 L12,13.4142136 L15.0428932,16.4571068 C15.4334175,16.8476311 16.0665825,16.8476311 16.4571068,16.4571068 C16.8476311,16.0665825 16.8476311,15.4334175 16.4571068,15.0428932 L13.4142136,12 L16.4571068,8.95710678 C16.8476311,8.56658249 16.8476311,7.93341751 16.4571068,7.54289322 C16.0665825,7.15236893 15.4334175,7.15236893 15.0428932,7.54289322 L12,10.5857864 Z M12,21 C7.02943725,21 3,16.9705627 3,12 C3,7.02943725 7.02943725,3 12,3 C16.9705627,3 21,7.02943725 21,12 C21,16.9705627 16.9705627,21 12,21 Z" />
    </g>
  </svg>
);

export default CircleXFilledIcon;
